import { useEffect } from 'react';
function createFuzzyRegex(keyword) {
    const escaped = keyword.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    return new RegExp(escaped.split('').join('[^a-zA-Z0-9]*'), 'i');
}
const bannedKeywords = ["medicare", "medicaid", "tricare", "medcare", "medcaid", "mecaid", "mcaid", "maid", "medcare", "mecare", "mcare", "trcare", "tcare"];
const bannedPatterns = bannedKeywords.map(createFuzzyRegex);
export function useEnrollmentBlock(insurance_name, setIsBlocked, setErrorMessage) {
    useEffect(() => {
        if (insurance_name) {
            const lowerName = insurance_name.toLowerCase();
            const isInvalid = bannedPatterns.some(pattern => pattern.test(lowerName));
            if (isInvalid) {
                setErrorMessage("Invalid insurance plan entered");
                setIsBlocked(true);
            } else {
                setErrorMessage("");
                setIsBlocked(false);
            }
        } else {
            setErrorMessage("");
            setIsBlocked(false);
        }
    }, [insurance_name, setIsBlocked, setErrorMessage]);
}